var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useMemo, useState } from 'react';
import { map } from 'rxjs/operators';
import { mapValues } from 'lodash';
import { Button, Paragraph, Card, CardContent, Dialog, DialogContainer, Text, Stack, Base, FormCheckbox, } from '@stepstone-genesis/components';
import { BrandGroup, getCurrentBrand } from '@stepstone/brand-helpers';
import { patchSearchability } from '../../api/service/SearchabilityService';
import { UploadArea } from '../UploadArea';
import { getLabel, replacePlaceholders, } from '../../utils/helpers/labelsService';
import { UploadAlert } from '../UploadAlert';
import { AttachmentItem } from '../AttachmentItem';
import { MODAL_DATA_AT, REDIRECT_TO_PROFILE_URL } from '../consts';
import { delay, getErrors, useIsBrandUk } from '../../utils/helpers/helpers';
import { sendLinkEvent, sendViewEvent } from '../../analitycs/analyticsService';
import * as api from '../api';
import { gcsConfig$, generateFileLimitsPlaceholders, defaultFileLimits, } from '../api';
import { useCurrentUrl } from '../../utils/helpers/url';
export var RegistrationSuccessModal = function (_a) {
    var _b;
    var open = _a.open, setOpen = _a.setOpen, redirectToProfileUrl = _a.redirectToProfileUrl, redirectToJobSearchUrl = _a.redirectToJobSearchUrl;
    var _c = useState(0), uploadProgress = _c[0], setUploadProgress = _c[1];
    var _d = useState(undefined), fileMetadata = _d[0], setFileMetadata = _d[1];
    var _e = useState([]), errors = _e[0], setErrors = _e[1];
    var _f = useState(true), checkboxChecked = _f[0], setCheckboxChecked = _f[1];
    var _g = useState({
        limits: defaultFileLimits,
        replacers: generateFileLimitsPlaceholders(defaultFileLimits),
    }), fileConfig = _g[0], setFileConfig = _g[1];
    var currentUrl = useCurrentUrl();
    var isBrandUk = useIsBrandUk();
    var attachmentErrorLabels = useMemo(function () { return getLabel('cvDropZone.errorLabels'); }, []);
    useEffect(function () {
        if (open) {
            sendViewEvent();
        }
    }, [open]);
    useEffect(function () {
        var subscription = gcsConfig$.subscribe(function (value) {
            setFileConfig({
                limits: value,
                replacers: generateFileLimitsPlaceholders(value),
            });
        });
        return function () { return subscription.unsubscribe(); };
    }, [gcsConfig$]);
    var _h = useState(false), displaySuccessAlert = _h[0], setDisplaySuccessAlert = _h[1];
    var header = useMemo(function () { return getLabel('header'); }, []);
    var completeMessage = useMemo(function () { return getLabel('complete'); }, []);
    var ctaCompleteProfile = useMemo(function () { return getLabel('cta.completeProfile'); }, []);
    var ctaContinueSearch = useMemo(function () { return getLabel('cta.continueSearch'); }, []);
    var brand = ((_b = getCurrentBrand(window.location.hostname)) === null || _b === void 0 ? void 0 : _b.name) || BrandGroup.Totaljobs;
    var ctaCandidateSearchable = useMemo(function () { return getLabel('cta.candidateSearchable', { brand: brand }); }, [brand]);
    useEffect(function () {
        var patchInitialValue = function () { return __awaiter(void 0, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, delay(500)];
                    case 1:
                        _a.sent();
                        return [4, patchSearchability(true)];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Error patching initial value:', error_1);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        }); };
        patchInitialValue();
    }, []);
    useEffect(function () {
        var updateSearchability = function () { return __awaiter(void 0, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, patchSearchability(checkboxChecked)];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error('Error updating searchability:', error_2);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        updateSearchability();
    }, [checkboxChecked]);
    var candidateSearchableOnChange = function () {
        setCheckboxChecked(function (prev) { return !prev; });
    };
    var onDismiss = function () {
        sendLinkEvent('PostRegistrationModalExit', null);
        setOpen(!open);
    };
    var checkErrorsTypeAndSetErrors = function (response) {
        var errors = getErrors(response, mapValues(attachmentErrorLabels, function (value) {
            return replacePlaceholders(value, fileConfig.replacers);
        }));
        if (errors.length) {
            setErrors(errors);
        }
        else {
            setErrors([getLabel('common.errors.internalServerError')]);
        }
    };
    var handleUpload = function (file) {
        setErrors([]);
        setFileMetadata({
            name: file.name,
            createdAt: '',
            successfullyUploaded: false,
        });
        setUploadProgress(0);
        api
            .uploadAttachment(file, fileConfig.limits)
            .pipe(map(function (ev) {
            if (ev instanceof ProgressEvent) {
                return Math.floor((ev.loaded / ev.total) * 100);
            }
            else {
                return ev;
            }
        }))
            .subscribe(function (response) {
            if (typeof response == 'number') {
                setUploadProgress(response);
            }
            else {
                setUploadProgress(undefined);
                if (!response.success) {
                    checkErrorsTypeAndSetErrors(response);
                }
                else {
                    setFileMetadata({
                        name: file.name,
                        createdAt: new Date().toISOString(),
                        successfullyUploaded: true,
                    });
                    sendLinkEvent('PostRegistrationModalCVCapture', 'uploadNewPrimaryCv');
                    setDisplaySuccessAlert(true);
                }
            }
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Dialog, { a11yLabel: header, isOpen: open, onDismiss: onDismiss, disclosure: React.createElement("span", null), size: "medium" },
            React.createElement(DialogContainer, { "data-at": MODAL_DATA_AT },
                React.createElement(Stack, { direction: "vertical" },
                    React.createElement(Stack, { direction: "vertical", wrapChildElement: false, mb: 'spaceS' },
                        React.createElement(Text, { size: ['xl', 'xxl'], fontWeight: "fontWeightBold", "data-at": "".concat(MODAL_DATA_AT, "-header") }, header),
                        !displaySuccessAlert && !(fileMetadata === null || fileMetadata === void 0 ? void 0 : fileMetadata.successfullyUploaded) && (React.createElement(Paragraph, null, completeMessage))),
                    React.createElement(Card, { mb: 'spaceS', "data-at": "".concat(MODAL_DATA_AT, "-upload-cv-section"), hasBorders: false },
                        React.createElement(UploadAlert, { displaySuccessAlert: displaySuccessAlert, setDisplaySuccessAlert: setDisplaySuccessAlert, errors: errors, setErrors: setErrors }),
                        !displaySuccessAlert && !(fileMetadata === null || fileMetadata === void 0 ? void 0 : fileMetadata.successfullyUploaded) && (React.createElement(CardContent, { p: ['spaceNone', 'spaceNone'] },
                            React.createElement(UploadArea, { fileConfig: fileConfig, uploading: !!uploadProgress, uploadPercentage: uploadProgress, uploadedFileName: (fileMetadata === null || fileMetadata === void 0 ? void 0 : fileMetadata.name) || '', dataAt: "".concat(MODAL_DATA_AT, "-upload-area-drag-n-drop"), handleUpload: handleUpload }))),
                        (fileMetadata === null || fileMetadata === void 0 ? void 0 : fileMetadata.successfullyUploaded) && (React.createElement(AttachmentItem, { attachment: fileMetadata }))),
                    React.createElement(Stack, { direction: "vertical", wrapChildElement: false },
                        isBrandUk && (React.createElement(Base, { marginBottom: 'spaceM' },
                            React.createElement(FormCheckbox, { onChange: candidateSearchableOnChange, checked: checkboxChecked }, ctaCandidateSearchable))),
                        React.createElement(Button, { as: "a", href: redirectToProfileUrl !== null && redirectToProfileUrl !== void 0 ? redirectToProfileUrl : REDIRECT_TO_PROFILE_URL, a11yLabel: ctaCompleteProfile, "data-at": "".concat(MODAL_DATA_AT, "-cta-profile"), variant: "secondary", onClick: function () {
                                return (fileMetadata === null || fileMetadata === void 0 ? void 0 : fileMetadata.successfullyUploaded)
                                    ? sendLinkEvent('PostRegistrationModalProfileCVSuccess', null)
                                    : sendLinkEvent('PostRegistrationModalProfile', null);
                            } }, ctaCompleteProfile),
                        React.createElement(Button, { as: "a", href: redirectToJobSearchUrl !== null && redirectToJobSearchUrl !== void 0 ? redirectToJobSearchUrl : currentUrl, a11yLabel: ctaContinueSearch, "data-at": "".concat(MODAL_DATA_AT, "-cta-search"), variant: !(fileMetadata === null || fileMetadata === void 0 ? void 0 : fileMetadata.successfullyUploaded) ? 'secondary' : 'primary', onClick: function () {
                                return (fileMetadata === null || fileMetadata === void 0 ? void 0 : fileMetadata.successfullyUploaded)
                                    ? sendLinkEvent('PostRegistrationModalJobSearchCVSuccess', null)
                                    : sendLinkEvent('PostRegistrationModalJobSearch', null);
                            } }, ctaContinueSearch)))))));
};
//# sourceMappingURL=RegistrationSuccessModal.js.map